export const productCategoryFieldMapping = [
  "product_category_id",
  "code",
  "name",
  "principal_id",
  "principal_name",
  "principal_code",
  "parent_id",
];
